import { Routes } from '@angular/router';
import { AuthzGuard } from '@pcscol-portail/ng-authz';
import { AccueilComponent } from './core/accueil/accueil.component';
import { NotFoundComponent } from './core/not-found/not-found.component';
import { ActivateOnglets } from './shared/auth/onglets.model';

export const piecesJustificativesTitle = $localize`:@@PIECES-MENU-PIECES-JUSTIFICATIVES:PIECES-MENU-PIECES-JUSTIFICATIVES`;

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('@app-shared/auth/auth-wrapper.module').then((m) => m.AuthWrapperModule),
  },
  {
    path: 'accueil',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: '',
    canActivate: [AuthzGuard],
    component: AccueilComponent,
  },
  {
    path: ':codeStructure',
    canActivate: [AuthzGuard],
    children: [
      {
        path: 'accueil',
        redirectTo: 'pieces-justificatives',
        pathMatch: 'full',
      },
      {
        path: '',
        redirectTo: 'pieces-justificatives',
        pathMatch: 'full',
      },
      {
        path: 'pieces-justificatives',
        loadComponent: () =>
          import('./features/pieces-justificatives/pieces-justificatives').then(
            (m) => m.PiecesJustificatives,
          ),
        data: {
          navTitle: piecesJustificativesTitle,
          matIcon: 'file_upload',
          canActivateOnglets: [ActivateOnglets.AUTH, ActivateOnglets.ID, ActivateOnglets.ENABLE],
        },
      },
    ],
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];
